import type { CBCT_SectionOrientation } from '@/shared/api/protocol-ts/model/dto_asset_common_pb';
import {
  ToothFullHeadMPRSliceView,
  ToothFullHeadMPRSliceView_SamplingMode,
} from '@/shared/api/protocol-ts/model/dto_report_tooth_pb';
import type {
  FullHeadMPRFocus,
  FullHeadMPRSavedView,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

import { FULL_HEAD_MPR_PROJECTION_TO_ORIENTATION } from '../config';

export {
  isSameFullHeadMprAnnotationPlane,
  isSameFullHeadMprPhysicalPlane,
  isSameFullHeadMprPlane,
  makeFullHeadMprPointTransform,
  resolveFullHeadMprSeriesContext,
} from '@/shared/graphics/medicalImageRender/MedicalImageRender';

export const makeFullHeadMprViewMessage = (
  view: FullHeadMPRSavedView,
  { orientation }: { orientation?: CBCT_SectionOrientation } = {},
) => {
  const point = ({ x, y, z }: FullHeadMPRFocus) => ({ X: x, Y: y, Z: z });
  return new ToothFullHeadMPRSliceView({
    CenterMm: point(view.centerMm),
    HeightMm: view.heightMm,
    Normal: point(view.normal),
    Orientation:
      orientation ?? FULL_HEAD_MPR_PROJECTION_TO_ORIENTATION[view.projection],
    SampleOffsetsMm: [...view.sampleOffsetsMm],
    Sampling:
      view.sampling === 'native'
        ? ToothFullHeadMPRSliceView_SamplingMode.Native
        : ToothFullHeadMPRSliceView_SamplingMode.MeanSlab,
    ThicknessMm: view.thicknessMm,
    UAxis: point(view.uAxis),
    VAxis: point(view.vAxis),
    VolumeFileID: view.volumeFileID,
    WidthMm: view.widthMm,
    WindowCenter: view.window.wc,
    WindowWidth: view.window.ww,
  });
};
